<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const alertVariants = ['success', 'error', 'info', 'warning'];

  const loudSnippet = `
    <div class="alert loud-alert-VARIANT">
      <div class="flex flex-no-wrap">
        <div class="alert-panel p-3">
          <div class="alert-icon"></div>
        </div>
        <div class="alert-content">
          <h4 class="heading heading-4 mb-3">An alert for VARIANT</h4>
          <div class="copy">This is an optional short description of the alert.</div>
        </div>
      </div>
    </div>
  `;

  const softSnippet = `
    <div class="alert soft-alert-VARIANT">
      <div class="flex flex-no-wrap">
        <div class="alert-panel p-3">
          <div class="alert-icon"></div>
        </div>
        <div class="alert-content">
          <h4 class="heading heading-4 mb-3">An alert for VARIANT</h4>
          <div class="copy">This is an optional short description of the alert.</div>
        </div>
      </div>
    </div>
  `;
</script>

<template>
  <section id="alert" class="page-section bg-white">
    <div class="container">
      <h2 class="heading heading-2 my-6">Alert</h2>
      <h3 class="heading heading-3 mt-8 mb-6">Loud Alerts</h3>
      {#each alertVariants as variant}
        <div class="my-8">
          <div class="text-center">
            {@html loudSnippet.replace(/VARIANT/g, variant)}
          </div>
          <CodeSnippet id="loud-alert-{variant}" snippet={loudSnippet.replace(/VARIANT/g, variant)} />
        </div>
      {/each}

      <h3 class="heading heading-3 mt-8 mb-6">Soft Alerts</h3>
      {#each alertVariants as variant}
        <div class="my-8">
          <div class="text-center">
            {@html softSnippet.replace(/VARIANT/g, variant)}
          </div>
          <CodeSnippet id="soft-alert-{variant}" snippet={softSnippet.replace(/VARIANT/g, variant)} />
        </div>
      {/each}
    </div>
  </section>
</template>
